import { Help } from 'views/dashboard/help';
import { OnboardingView } from 'views/onboarding/onboarding';
import {_t} from "../app/translations";

const Routes = [
  {
    path: '/app/onboarding',
    view: OnboardingView,
    layout: 'onboarding',
    permission: 'user',
    title: _t('welcome'),
    allowNotOnboarded: true
  },
  {
    path: '/app/help',
    view: Help,
    layout: 'app',
    permission: 'user',
    title: _t('help.label')
  }
]

export default Routes;
